import { Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';

export const PUBLIC_PAGES_ROUTES: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];
